// extracted by css-extract-rspack-plugin
export default {"toggletip":"toggletip-1BZrh","arrow":"arrow-1TrGl"};